import React, { useState, useEffect } from 'react';
import "./Rightpart.css";
import profile from "../assets/images/profile.png";
import ordersdetail from "../assets/images/order-detail.png";
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined';
import FmdGoodOutlinedIcon from '@mui/icons-material/FmdGoodOutlined';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import axios from '../../api/axios';
import { Link, useNavigate } from 'react-router-dom';

export default function OrderdetailRight() {
  const [user, setUser] = useState(null);
  const [orderInfo, setOrderInfo] = useState(null);
  const [orderItems, setOrderItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // Get order ID from query parameter
  const queryParams = new URLSearchParams(window.location.search);
  const orderId = queryParams.get("id");

  const handleProfileUpdate = () => {
    const userData = localStorage.getItem("user");
    if (userData) {
      setUser(JSON.parse(userData));
    }
  };

  const fetchOrderDetail = async () => {
    if (!orderId) {
      setLoading(false);
      return;
    }
    const token = localStorage.getItem("access_token");
    if (!token) {
      navigate("/login");
      return;
    }

    try {
      setLoading(true);
      // Fetch Order Meta Details
      const detailsRes = await axios.get(`/purchase-history-details/${orderId}`);
      if (detailsRes.data && detailsRes.data.data && detailsRes.data.data.length > 0) {
        setOrderInfo(detailsRes.data.data[0]);
      }

      // Fetch Order Items List
      const itemsRes = await axios.get(`/purchase-history-items/${orderId}`);
      if (itemsRes.data && itemsRes.data.data) {
        setOrderItems(itemsRes.data.data);
      }
      setLoading(false);
    } catch (err) {
      console.error("Error fetching order details:", err);
      setLoading(false);
    }
  };

  useEffect(() => {
    handleProfileUpdate();
    window.addEventListener("user-profile-updated", handleProfileUpdate);

    fetchOrderDetail();

    return () => {
      window.removeEventListener("user-profile-updated", handleProfileUpdate);
    };
  }, [orderId]);

  const handleLogout = () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("user");
    localStorage.removeItem("wishlist_slugs");
    window.dispatchEvent(new Event("user-profile-updated"));
    window.dispatchEvent(new Event("wishlist-slugs-updated"));
    axios.get("/auth/logout").catch(() => {});
    navigate("/login");
  };

  const handleDownloadInvoice = async () => {
    if (!orderId) return;
    try {
      const response = await axios.get(`/invoice/download/${orderId}`, {
        responseType: 'blob', // important for binary data
      });
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `invoice-order-${orderInfo?.code || orderId}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (err) {
      console.error("Error downloading invoice:", err);
      alert("Failed to download invoice.");
    }
  };

  if (loading) {
    return (
      <div className="order-detail-main-outer d-flex align-items-center justify-content-center" style={{ minHeight: "400px" }}>
        <div className="spinner-border text-dark" role="status">
          <span className="visually-hidden">Loading order details...</span>
        </div>
      </div>
    );
  }

  if (!orderInfo) {
    return (
      <div className="order-detail-main-outer d-flex flex-column align-items-center justify-content-center" style={{ minHeight: "400px" }}>
        <h4>Order not found.</h4>
        <Link to="/purchasehistory" className="btn btn-dark btn-sm mt-3">Back to Purchase History</Link>
      </div>
    );
  }

  const shippingAddress = orderInfo.shipping_address;

  return (
    <div className='order-detail-main-outer'>
      <div className='order-detail-content'>
         <div className='dashbord-header'>
            <p className='title-dash'>Order Detail</p>
          <div className="dropdown-section d-flex align-items-center">
            <div className="dropdown">
              <button
                className="btn dropdown-toggle d-flex align-items-center gap-3"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <div className="profile-name">
                  <img src={user?.avatar_original || user?.avatar || profile} alt="" style={{ width: '40px', height: '40px', borderRadius: '50%' }} />
                  <div className="name-mail">
                    <h4>{user?.name || "User"}</h4>
                    <p>{user?.email || user?.phone || "Email/Phone"}</p>
                  </div>
                </div>
                <ExpandMoreIcon />
              </button>

              <ul className="dropdown-menu ">
                <li>
                  <Link className="dropdown-item" to="/profile">
                    Profile
                  </Link>
                </li>
                <li>
                  <Link className="dropdown-item" to="/support">
                    Support
                  </Link>
                </li>
                <li>
                  <button onClick={handleLogout} className="dropdown-item w-100 text-start border-0 bg-transparent">
                    Logout
                  </button>
                </li>
              </ul>
            </div>
          </div>
         </div>
         <div className='outer-box-oc'>
            <div className='row'>
              <div className='col-lg-7 col-12'>
                    <div className='sr-sec'>
                        <div className='box-top'>
                            <div className='sr-number'>
                                <h4>Order ID: #{orderInfo.code}</h4>
                            </div>
                            <div className='sr-date'>
                                <p>Date: {orderInfo.date}</p>
                            </div>
                        </div>
                        
                        {orderItems.map((item) => (
                          <div className='loxer-sr' key={item.id}>
                             <div className='content-prices'>
                                 <div className='img-sr'>
                                    {item.product_slug ? (
                                      <Link to={`/product/${item.product_slug}`}>
                                        <img src={item.product_thumbnail || ordersdetail} alt={item.product_name} style={{ width: '80px', height: '80px', objectFit: 'cover', borderRadius: '6px' }} />
                                      </Link>
                                    ) : (
                                      <img src={item.product_thumbnail || ordersdetail} alt={item.product_name} style={{ width: '80px', height: '80px', objectFit: 'cover', borderRadius: '6px' }} />
                                    )}
                                 </div>
                                 <div className='text-sr-prices'>
                                     <div className='text-sr'>
                                         <h5>
                                           {item.product_slug ? (
                                             <Link to={`/product/${item.product_slug}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                                               {item.product_name}
                                             </Link>
                                           ) : (
                                             item.product_name
                                           )}
                                         </h5>
                                         <div className="product-info">
                                            {item.variation && <p>Variant: {item.variation}</p>}
                                         </div>
                                         <p className="qty">Qty : {item.quantity}</p>
                                     </div>
                                     <div className='sr-prices'>
                                         <p>{item.price}</p>
                                     </div>
                                 </div>
                             </div>
                          </div>
                        ))}
                    </div>
                </div>

                <div className='col-lg-5 col-12'>
                    <div className='cst-info'>
                        <div className='cst-header box-top'>
                            <h5>Customer Information</h5>
                        </div>
                        <div className='detail-cst'>
                            <div className='icon-info'>
                               <PersonOutlineOutlinedIcon />
                               <p>{shippingAddress?.name || user?.name}</p>
                            </div>
                             <div className='icon-info'>
                               <EmailOutlinedIcon />
                               <p>{shippingAddress?.email || user?.email || "N/A"}</p>
                            </div>
                             <div className='icon-info'>
                               <LocalPhoneOutlinedIcon />
                               <p>{shippingAddress?.phone || user?.phone || "N/A"}</p>
                            </div>
                             <div className='icon-info'>
                               <FmdGoodOutlinedIcon />
                               <p>
                                 {shippingAddress ? (
                                   `${shippingAddress.address || ""}, ${shippingAddress.city || ""}, ${shippingAddress.state || ""}, ${shippingAddress.country || ""} ${shippingAddress.postal_code || ""}`
                                 ) : (
                                   "No address provided."
                                 )}
                               </p>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div className='col-lg-7 col-12'>
                    <div className='payment-order'>
                         <div className='box-top'>
                            <div className='sr-number'>
                                <h4>Payment: <span className="small text-muted" style={{ fontSize: '0.9rem' }}>({orderInfo.payment_type})</span></h4>
                            </div>
                            <div className='sr-date pyment-invoice'>
                                <p style={{ cursor: 'pointer' }} onClick={handleDownloadInvoice}>Download Invoice</p>
                            </div>
                        </div>
                        <div className='pymt-box'>
                            <div className='nme-price'>
                                <p className='pmt-box-text'>Subtotal ({orderItems.length} Items)</p>
                                <p className='pmt-box-price'>{orderInfo.subtotal}</p>
                            </div>
                            <div className='nme-price'>
                                <p className='pmt-box-text'>Tax</p>
                                <p className='pmt-box-price'>{orderInfo.tax}</p>
                            </div>
                            <div className='nme-price'>
                                <p className='pmt-box-text'>Discount</p>
                                <p className='pmt-box-price'>{orderInfo.coupon_discount}</p>
                            </div>
                            <div className='nme-price'>
                                <p className='pmt-box-text'>Shipping</p>
                                <p className='pmt-box-price'>
                                  {orderInfo.shipping_cost === "₹0.00" || orderInfo.shipping_cost === "₹0" ? "Free Shipping" : orderInfo.shipping_cost}
                                </p>
                            </div>
                            <div className='nme-price total-price'>
                                <h5 className='total-t'>TOTAL</h5>
                                <p className='total-pricee'>{orderInfo.grand_total}</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='col-lg-5 col-12'>
                    <div className='billing-add-box'>
                        <div className='box-top'>
                            <div className='sr-number'>
                                <h4>Billing address</h4>
                            </div>
                        </div>
                        <div className='billing-text'>
                            <p>Same as shipping address</p>
                        </div>
                    </div>
                </div>
            </div>
         </div>
      </div>
    </div>
  );
}
